export default "__VITE_ASSET__DsisWM53__"